import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'

import CaseStudiesHRContent from './../components/CaseStudies/CaseStudiesHRContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';

const CaseStudiesHR = () => {
  const {t} = useTranslation()

  const language = useSelector(selectLanguage)


  useEffect(() => {
    document.title = t('case-studies-hr-page.case-studies-hr-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
        <NavbarTop/>
        <CaseStudiesHRContent/>
        
    </>
  )
}

export default CaseStudiesHR